import { getGridStringOperators } from "@mui/x-data-grid-pro";
import { WithDoc } from "@poseidon/firebase/components/WithDoc";
import { timestampColumn } from "../../DataGrid/ColumnHelpers";

const renderApplications = (params) => {
  const { row } = params;
  if (row.application) {
    return (
      <WithDoc
        docRef={row.application}
        Component={({ data }) => data.applicationNumber}
      />
    );
  }
  return "";
};
const renderAgreements = (params) => {
  const { row } = params;
  if (row.agreement) {
    return (
      <WithDoc
        docRef={row.agreement}
        Component={({ data }) => data.agreementNumber}
      />
    );
  }
  return "";
};

const filterOperators = getGridStringOperators().filter(
  (operator) => operator.value === "equals"
);

export const columns = [
  {
    field: "id",
    headerName: "ID",
    width: 180,
    filterOperators,
  },
  {
    field: "hin",
    headerName: "Hull Identification Number",
    width: 160,
    filterOperators,
    hideable: false,
  },
  {
    field: "model",
    headerName: "Model",
    description: "",
    sortable: false,
    width: 180,
    filterOperators,
  },
  {
    field: "make",
    headerName: "Make",
    description: "",
    sortable: false,
    width: 180,
    filterOperators,
  },
  {
    field: "type",
    headerName: "Type",
    description: "",
    sortable: false,
    width: 180,
    filterOperators,
  },
  {
    field: "applications",
    headerName: "Application",
    sortable: false,
    width: 160,
    filterOperators,
    renderCell: renderApplications,
  },
  {
    field: "agreements",
    headerName: "Agreement",
    sortable: false,
    width: 160,
    filterOperators,
    renderCell: renderAgreements,
  },
  timestampColumn({
    field: "createdAt",
    headerName: "Created At",
  }),
];
